export const shirtNftAdd = '0xCb8c17df50C5D7695A88e45284Dc27b880f58c64';